import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Areas.css';
import Logo1 from '../../../assets/HomePageImages/Logo1.png'
import Logo2 from '../../../assets/HomePageImages/Logo2.png'
import Logo3 from '../../../assets/HomePageImages/Logo3.png'
import Logo4 from '../../../assets/HomePageImages/Logo4.png'
import Logo5 from '../../../assets/HomePageImages/Logo5.png'
import Logo6 from '../../../assets/HomePageImages/Logo6.png'
/* ─── Intersection Observer Hook ─── */
function useInView(options = {}) {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.unobserve(element);
        }
      },
      {
        threshold: 0.1,
        ...options,
      }
    );

    observer.observe(element);
    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, isInView];
}

/* ─── Slug Helper ─── */
const toSlug = (name) =>
  name.toLowerCase().replace(/,\s*/g, '-').replace(/\s+/g, '-');

/* ─── Component ─── */
const Areas = () => {
  const areas = [
    'Columbus, Ohio',
    'Dublin, Ohio',
    'Hilliard, Ohio',
    'Powell, Ohio',
    'Marysville, Ohio',
    'Reynoldsburg, Ohio',
    'Blacklick, Ohio',
    'Gahanna, Ohio',
    'Delaware, Ohio',
  ];

  const brands = [
    { src: Logo1, alt: 'Weiser' },
    { src: Logo2, alt: 'Kwikset' },
    { src: Logo3, alt: 'Clopay' },
    { src: Logo4, alt: 'Amarr' },
    { src: Logo5, alt: 'Andersen' },
    { src: Logo6, alt: 'JELD-WEN' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/garaga4.jpg', alt: 'Garaga' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-14567667697.jpg', alt: 'Ridgeway' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-154447.jpg', alt: 'Steel Craft' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-145658634.jpg', alt: 'Loewen' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-1356658.jpg', alt: 'Richards-Wilcox' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-1466.jpg', alt: 'Ply Gem' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weise566857463.jpg', alt: 'Pollard' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-1346747546.jpg', alt: 'Vanfax' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-134565457346.jpg', alt: 'Dalmen Pro' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-1354668545.jpg', alt: 'Belron' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-135675.jpg', alt: 'Bigfoot Door' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/wei6765756346.jpg', alt: 'NordGlass' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/weiserlogo-135675.jpg', alt: 'Bigfoot Door' },
    { src: 'https://fixone.ca/wp-content/uploads/2025/03/wei6765756346.jpg', alt: 'NordGlass' },
  ];


  const [leftRef, leftInView] = useInView();
  const [rightRef, rightInView] = useInView();

  return (
    <div style={{ backgroundColor: '#f8f9fa' }}>
      <div className="areas-scope">
        <section className="areas-serve-section">

          <div className="container-fluid px-3 px-md-4 px-lg-5">
            <div className="row g-4 g-lg-5 d-flex align-items-start">

              {/* ─── LEFT SIDE ─── */}
              <div className="col-lg-6" ref={leftRef}>

                <div
                  className={
                    leftInView
                      ? 'areas-animate-fade-left'
                      : 'areas-opacity-0'
                  }
                >
                  <h2 className="areas-section-heading text-center text-lg-start">
                    We Serve{' '}
                    <span className="areas-red">
                      Across Central Ohio
                    </span>
                  </h2>

                  <div className="d-flex justify-content-center justify-content-lg-start">
                    <div className="areas-heading-underline"></div>
                  </div>

                  <p className="areas-intro-p text-center text-lg-start">
                   We proudly provide professional roofing services across Ohio, and surrounding cities, including:
                  </p>
                </div>

                {/* Areas List */}
                <ul className="areas-list mt-3">
                  {areas.map((area, i) => (
                    <li
                      key={i}
                      className={
                        leftInView
                          ? 'areas-animate-fade-left'
                          : 'areas-opacity-0'
                      }
                      style={{ animationDelay: `${i * 0.05}s` }}
                    >
                      <Link
                        to={`/location/${toSlug(area)}`}
                        className="areas-link"
                        style={{
                          textDecoration: 'none',
                          color: 'inherit',
                        }}
                      >
                        <span className="areas-icon">
                          <i className="bi bi-geo-alt-fill"></i>
                        </span>
                        <span className="areas-name">{area}</span>
                      </Link>
                    </li>
                  ))}
                </ul>

                <div 
                  className={
                    leftInView
                      ? 'areas-animate-fade-up areas-note mt-4'
                      : 'areas-opacity-0 areas-note mt-4'
                  }
                  style={{ animationDelay: '0.6s' , backgroundColor: '#f8f9fa'}}
                >
                  <p>
                    <strong>
                      Ultimates Roofing proudly serves homeowners and businesses across  Ohio and the surrounding areas with trusted residential 
                      and commercial roofing solutions.
                    </strong>
                  </p>
                </div>
              </div>

              {/* ─── RIGHT SIDE ─── */}
              <div className="col-lg-6 areas-brands-col" ref={rightRef}>

                <div
                  className={
                    rightInView
                      ? 'areas-animate-fade-right'
                      : 'areas-opacity-0'
                  }
                >
                  <h2 className="areas-brands-heading text-center text-lg-start">
                    Brands <span className="areas-red">We Trust</span>
                  </h2>

                  <div className="d-flex justify-content-center justify-content-lg-start">
                    <div className="areas-heading-underline"></div>
                  </div>
                </div>

                {/* Brands Grid */}
                <div className="areas-brands-grid">
                  {brands.map((brand, i) => (
                    <div
                      key={i}
                      className={
                        rightInView
                          ? 'areas-brand-card areas-animate-fade-up'
                          : 'areas-brand-card areas-opacity-0'
                      }
                      style={{ animationDelay: `${i * 0.05}s` }}
                    >
                      <img src={brand.src} alt={brand.alt} loading="lazy" />
                    </div>
                  ))}
                </div>

              </div>

            </div>
          </div>

        </section>
      </div>
    </div>
  );
};

export default Areas;